import createIcon from '../../createIcon';

/**
 * @component @name SignalCellularNoSim
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuMjM5OSA0LjE5MDQzQzE5LjIzOTkgMy4wOTA0MyAxOC4zNDk5IDIuMTkwNDMgMTcuMjQ5OSAyLjE5MDQzSDEwLjI0OTlMNy45MDk4OCA0LjUzMDQzTDE5LjI0OTkgMTUuODcwNEwxOS4yMzk5IDQuMTkwNDNaTTMuODk5ODggMy4wNzA0M0wyLjYyOTg4IDQuMzQwNDNMNS4yNDk4OCA2Ljk2MDQzVjE4LjE5MDRDNS4yNDk4OCAxOS4yOTA0IDYuMTQ5ODggMjAuMTkwNCA3LjI0OTg4IDIwLjE5MDRIMTcuMjU5OUMxNy42MDk5IDIwLjE5MDQgMTcuOTI5OSAyMC4wOTA0IDE4LjIxOTkgMTkuOTMwNEwyMC4wOTk5IDIxLjgxMDRMMjEuMzY5OSAyMC41NDA0TDMuODk5ODggMy4wNzA0M1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalCellularNoSim = createIcon('SignalCellularNoSim', [
  [
    'path',
    {
      d: 'M19.2399 4.19043C19.2399 3.09043 18.3499 2.19043 17.2499 2.19043H10.2499L7.90988 4.53043L19.2499 15.8704L19.2399 4.19043ZM3.89988 3.07043L2.62988 4.34043L5.24988 6.96043V18.1904C5.24988 19.2904 6.14988 20.1904 7.24988 20.1904H17.2599C17.6099 20.1904 17.9299 20.0904 18.2199 19.9304L20.0999 21.8104L21.3699 20.5404L3.89988 3.07043Z',
      key: '1snrel',
    },
  ],
]);

export default SignalCellularNoSim;
